export default __webpack_public_path__ + "static/hero_banner-5a5b04cf5b5e63f81a37bec58588ddce.svg";